// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconSearch_cursor__2brco","root":"IconSearch_root__1n1mK"};